import { PayloadAction } from '@reduxjs/toolkit'
import { ThemeState } from '../theme.slice'
import { setSettingsValue } from '../../../components/common/utility/helpers'

export const changeThemeReducer = (
    state: ThemeState,
    action: PayloadAction<string>
): void => {
    const { payload } = action
    state.theme = payload || 'light'

    document.documentElement.setAttribute('data-bs-theme', state.theme)
    setSettingsValue('theme', state.theme)
}
